export const API_ACTIVITY_KEY = "api-activity";
export const LOGOUT_KEY = "user-logout";
export const DISABLE_AUTO_LOGOUT_KEY = "disable-auto-logout";

export const recordApiActivity = () => {
  localStorage.setItem(API_ACTIVITY_KEY, Date.now().toString());
};